export const ShoppingCart = (function () {
	'use strict';

	let $addToCart;

	function init() {
		$addToCart = $('.je_single_add_to_cart_button');
		
		$.scroll_to_notices = function( scrollElement ) {
			// Your changes ...
			return;
		};
	
		if($addToCart.hasClass('added')) {
			// console.log('jas the class');
			setTimeout(() => {
				// console.log('remove the class');
				$addToCart.removeClass('added');
			}, 7000);
		}
	}

	return {
		init: init,
	};
})();
